import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { useAuthStore } from '../../auth/stores/authStore';

export const labourItemDetailsKeys = {
  all: ['labourItemDetails'] as const,
  details: () => [...labourItemDetailsKeys.all, 'detail'] as const,
  detail: (
    siteId: number,
    plotId: number,
    labourItemId: number,
    isAuthenticated: boolean
  ) =>
    [
      ...labourItemDetailsKeys.details(),
      { siteId, plotId, labourItemId, isAuthenticated },
    ] as const,
};

export function useLabourItemDetails(
  siteId: number | null,
  plotId: number | null,
  labourItemId: number | null
) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  const { data, error, isFetching } = useQuery({
    queryKey: labourItemDetailsKeys.detail(
      siteId ?? 0,
      plotId ?? 0,
      labourItemId ?? 0,
      isAuthenticated
    ),
    queryFn: async ({ signal }) => {
      if (!siteId || !plotId || !labourItemId) return null;
      return unwrap(
        await api.legacy.GET(
          '/api/v2/sites/{siteId}/plots/{plotId}/labour-items/{labourItemId}',
          {
            params: { path: { siteId, plotId, labourItemId } },
            signal,
          }
        )
      );
    },
    placeholderData: previousData => previousData,
    enabled: isAuthenticated && !!siteId && !!plotId && !!labourItemId,
    staleTime: 30000,
  });

  return { data, error, isFetching };
}
